import React from "react";

import { Icon, IconProps } from "../";

export const SignalCellularIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        d="m188 1735h1c.552285 0 1 .44772 1 1v4c0 .55228-.447715 1-1 1h-1c-.552285 0-1-.44772-1-1v-4c0-.55228.447715-1 1-1zm5-4h1c.552285 0 1 .44772 1 1v8c0 .55228-.447715 1-1 1h-1c-.552285 0-1-.44772-1-1v-8c0-.55228.447715-1 1-1zm5-4h1c.552285 0 1 .44772 1 1v12c0 .55228-.447715 1-1 1h-1c-.552285 0-1-.44772-1-1v-12c0-.55228.447715-1 1-1zm5-4h1c.552285 0 1 .44772 1 1v16c0 .55228-.447715 1-1 1h-1c-.552285 0-1-.44772-1-1v-16c0-.55228.447715-1 1-1z"
        fillRule="evenodd"
        transform="translate(-184 -1720)"
      />
    </Icon>
  );
};
